<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="content-wrapper">
      <div class="container">
        <article>
          <template v-if="inspectionFlag">
            <h2 class="fs16 mt16 mb12 pl4p pr4p">コミっと車検</h2>
            <div class="border-solid-gray bg-white radius16 pd16 ml12 mr12 mt2p mb24">
              <div class="flex mb4">
                <p class="car-image radius50p">
                  <img src="/lib/images/ic_car.svg" alt="" class="car-img">
                </p>
                <div class="flex1 pl8">
                  <p class="fs14 mt4 mb4">{{ Manufacturer.manufacturer_name }} {{ firstRegistrationOnWareki.gengo }}{{ $filters.checkFirstYear(firstRegistrationOnWareki.year) }}年{{ firstRegistrationOnWareki.month }}月登録</p>
                  <p class="fs12 color-font2">車検受付ID {{ detail[0].id }}</p>
                  <p class="fs13" v-if="detail[0].status_code === 1 || detail[0].status_code === 2">見積り金額 <span class="fs16">{{ $filters.addComma(detail[0].estimate_price) }}</span>円</p>
                  <p class="fs13" v-if="detail[0].status_code === 3">見積り金額 <span class="fs16">{{ $filters.addComma(detail[0].before_maintenance_price) }}</span>円</p>
                  <p class="fs13" v-if="detail[0].status_code === 4 || detail[0].status_code === 5">精算金額 <span class="fs16">{{ $filters.addComma(detail[0].payment_price) }}</span>円</p>
                </div>
              </div>
              <hr class="hr-solid-gray mb16">

              <div class="progress-wrap-02 progress-4steps car-inspection-flow mb16">
                <ul class="progressbar-02 clearfix" v-if="detail[0].status_code === 1">
                  <li class="li-01 active"><span><img src="/lib/images/carcare_ic_status01_active.svg"></span></li>
                  <li class="li-02"><span><img src="/lib/images/carcare_ic_status02.svg"></span></li>
                  <li class="li-03"><span><img src="/lib/images/carcare_ic_status03.svg"></span></li>
                  <li class="li-04"><span><img src="/lib/images/carcare_ic_status04.svg"></span></li>
                </ul>
                <ul class="progressbar-02 clearfix" v-if="detail[0].status_code === 2">
                  <li class="li-01 passed"><span><img src="/lib/images/carcare_ic_status01.svg"></span></li>
                  <li class="li-02 active"><span><img src="/lib/images/carcare_ic_status02_active.svg"></span></li>
                  <li class="li-03"><span><img src="/lib/images/carcare_ic_status03.svg"></span></li>
                  <li class="li-04"><span><img src="/lib/images/carcare_ic_status04.svg"></span></li>
                </ul>
                <ul class="progressbar-02 clearfix" v-if="detail[0].status_code === 3">
                  <li class="li-01 passed"><span><img src="/lib/images/carcare_ic_status01.svg"></span></li>
                  <li class="li-02 passed"><span><img src="/lib/images/carcare_ic_status02.svg"></span></li>
                  <li class="li-03 active"><span><img src="/lib/images/carcare_ic_status03_active.svg"></span></li>
                  <li class="li-04"><span><img src="/lib/images/carcare_ic_status04.svg"></span></li>
                </ul>
                <ul class="progressbar-02 clearfix" v-if="detail[0].status_code === 4 || detail[0].status_code === 5">
                  <li class="li-01 passed"><span><img src="/lib/images/carcare_ic_status01.svg"></span></li>
                  <li class="li-02 passed"><span><img src="/lib/images/carcare_ic_status02.svg"></span></li>
                  <li class="li-03 passed"><span><img src="/lib/images/carcare_ic_status03.svg"></span></li>
                  <li class="li-04 active"><span><img src="/lib/images/carcare_ic_status04_active.svg"></span></li>
                </ul>
              </div>
              <p class="fs14 font-weight-bold mb20" v-if="detail[0].status_code === 1">店舗からのお電話をお待ち下さい。</p>
              <p v-else></p>
              <p class="fs13 font-weight-bold color-red2 text-center mb4" v-if="webviewMaintenance.inspection">
                誠に申し訳ありませんが、ただいまメンテナンス<br>中につき、ご利用いただくことが出来ません。<br>お時間をあけてから再度アクセスをお願い致します。
              </p>
              <div class="transparent-panel" v-else>
                <button v-on:click='inspectionTopPage(nativeData, versionData)' class="button fs16 mt8 mb16 pd16 radius200">次へ</button>
              </div>
            </div>
          </template>
          <template v-if="!inspectionFlag">
            <noscript v-if="isViewGatag" v-html="noscriptContent"></noscript>
            <main>
            <section class="cosmo-shakencms-c-section -top cosmo-shakencms-top-s-mainvisual">
            <div class="fv_bg">
              <div class="cosmo-shakencms-c-inner">
                <div class="s-mainvisual__wrap">
                  <div class="s-mainvisual__wrap__inner">
                    <div class="fv_title">
                      <img src="/lib/images/inspectiondetail/fv/fv_top_sp.png" alt="手軽に車検、オンラインで簡単見積り。「コスモのコミっと車検」" />
                      <div class="fv_title__logo">
                        <img src="/lib/images/inspectiondetail/fv/fv_logo_sp.png" alt="COSMO" />
                      </div>
                    </div>
                    <div class="fv_main">
                      <img src="/lib/images/inspectiondetail/fv/fv_bottom_sp.png" alt="見積りからブレないから安心だよ。※" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="fv_bg__btn">
                <div class="btn__top">
                  <img src="/lib/images/inspectiondetail/fv/fv_btn_top_sp.png" alt="「３つの特徴」POINT.1「お近くのコスモSSで安心対応！」POINT.2「来店不要！オンラインで簡単見積り！」POINT.3「コミコミ価格で見積りからのブレがない」" />
                </div>
                <div class="btn__bottom">
                  <a v-on:click='nextPage(ssInfo, profileInfo, nativeData, versionData)'>
                    <img src="/lib/images/inspectiondetail/fv/fv_btn_sp.png" alt="オンラインで見積り" />
                  </a>
                </div>
              </div>
            </div>
            <div class="carcare-fv-notice">
              <div class="carcare-fv-notice__inner">
                <p class="font-weight-bold">【重要なお知らせ】</p>
                <br>
                <p>現在、原材料の供給停止、不足等の影響により、一部定額対象部品の供給が不安定な状態となっております。一部定額対象部品がご用意できない場合は、以下の通り対応させていただく場合がございます。</p>
                <br>
                <p>①コミっと車検をご検討の方</p>
                <p>別の車検商品でのご案内に切り替えさせていただくことがございます。</p>
                <br>
                <p>②整備保証対象の方</p>
                <p>無償交換の対象ではございますが、対象部品の受け入れ・交換対応ができない場合がございます。</p>
                <br>
                <p>予めご了承ください。</p>
              </div>
            </div>
            </section>
            <!-- step-area -->
            <div class="step-area">
              <!-- step-area01 -->
              <section class="cosmo-shakencms-c-section -top cosmo-shakencms-top-s-price bg_third_blue step-area__height"></section>
              <!-- step-area02 -->
              <section class="cosmo-shakencms-top-s-price bg_shirosumire">
                <div class="section03">
                  <div class="section03__triangle"></div>
                </div>
              </section>
              <!-- step-area03 -->
              <section class="cosmo-shakencms-c-section -top cosmo-shakencms-step step-area__absolute">
                <div class="cosmo-shakencms-c-inner section02">
                  <div class="section02__title">
                    <img src="/lib/images/inspectiondetail/section02/section02_title_sp.png" alt="オンラインで即見積り「コミっと車検」の流れ３ステップ" />
                  </div>
                </div>
              </section>
            </div>
            <!-- / step-area -->

            <!-- section02 -->
            <section class="cosmo-shakencms-c-section -top cosmo-shakencms-step bg_shirosumire">
              <div class="cosmo-shakencms-c-inner section02 sp_padding-none">
                <div class="section02__item">
                  <ul>
                    <li>
                      <img src="/lib/images/inspectiondetail/section02/section02_item01_sp.png" alt="Step.1「お好みの方法でカンタン見積り」Webでもアプリでも簡単に、法定費用・車検基本料・主要部品の整備費見積り金額は無料ですぐに確認できるので、ぜひお見積りください！" />
                    </li>
                    <li>
                      <img src="/lib/images/inspectiondetail/section02/section02_item02_sp.png" alt="Step.2「来店日を予約」実施希望の日時を選択してお申込してください。こちらのご入力内容で来店日時を確定させていただきます。※一部の実施店舗や実施希望日時を選択していない場合はお申込頂いた、実施店舗からお電話をさせていただき来店日時を確定させていただきます。" />
                    </li>
                    <li>
                      <img src="/lib/images/inspectiondetail/section02/section02_item03_sp.png" alt="Step.3「車検当日」当日は店頭にお越しください。車検完了後には、お車の状態や整備箇所をわかりやすくお伝えしてお返しします。" />
                    </li>
                  </ul>
                </div>
                <div class="section02__item__bottom">
                  <img src="/lib/images/inspectiondetail/section02/section02_title_bottom_sp.png" alt="見積り金額は無料ですぐに確認できるので、ぜひお見積りください！" />
                </div>
              </div>
            </section>

            <!-- section04 -->
            <section class="cosmo-shakencms-top-s-price section04" id="features">
              <div class="cosmo-shakencms-c-section -top cosmo-shakencms-top-s-price bg_cream">
                <div class="cosmo-shakencms-c-inner sp_padding-none">
                  <div class="section04_title">
                    <img src="/lib/images/inspectiondetail/section04/section04_title_sp.png" alt="コミっと車検とは？" />
                  </div>
                  <div class="section04_item">
                    <img src="/lib/images/inspectiondetail/section04/section04_item_sp.png" alt="法定費用＋車検基本料＋主要部品の整備費用＋アフターサービス" />
                  </div>
                  <div class="section04_bottom">
                    <img src="/lib/images/inspectiondetail/section04/section04_title_bottom_sp.png" alt="と諸費用がコミコミなので、安心な車検サービスです！" />
                  </div>
                </div>
              </div>
            </section>

            <!-- section07 -->
            <section class="cosmo-shakencms-c-section -top cosmo-shakencms-top-s-price pb">
              <div class="section07">
                <div class="cosmo-shakencms-c-inner sp_padding-none">
                  <!-- title -->
                  <div class="section07__title img-01">
                    <img src="/lib/images/inspectiondetail/section07/section07_title-01_sp.png" alt="要するに初期の見積りから全てコミコミ※でご提示するので変動がありません！" />
                  </div>
                  <!-- item -->
                  <div class="section07__item">
                    <img src="/lib/images/inspectiondetail/section07/section07_item_sp.png" alt="" />
                  </div>
                  <p class="chu">※タイヤなど、交換する部品によっては、追加費用が発生する場合もあります。</p>
                </div>
              </div>
              <div class="section_btn">
                <a v-on:click='nextPage(ssInfo, profileInfo, nativeData, versionData)' v-if="!webviewMaintenance.inspection">
                  <img src="/lib/images/inspectiondetail/btn_sp.png" alt="コミっと車検無料お見積り" />
                </a>
              </div>
            </section>

            <!-- section01 -->
            <section class="cosmo-shakencms-c-section -top cosmo-shakencms-top-s-price slider-parts" id="price">
              <div class="cosmo-shakencms-c-inner slider-box slider-box_width">
                <div class="slider_title">
                  <div class="slider_title__inner">
                    <img src="/lib/images/inspectiondetail/section01/slider_title_sp.png" alt="" />
                    <div class="slider_title__inner__text">
                      <p class="responsive-font-size"><span class="color_light-blue">初年度登録から5年、走行距離50,000km</span>の車の金額がコチラ！</p>
                    </div>
                  </div>
                  <div class="slider_title__sub">
                    <p>一 例</p>
                  </div>
                  <div class="swiper-container js-slider__price">
                    <ul class="swiper-wrapper">
                      <li class="swiper-slide car_box">
                        <div class="car_box__item"><img src="/lib/images/inspectiondetail/section01/example_1.png" alt="ホンダ N-BOX 軽自動車"></div>
                        <div class="car_box__price">
                          <h3>ホンダ N-BOX<br>軽自動車</h3>
                          <p class="price">{{ inspectionExamplePrices.nbox }}<span class="tax">円（税込）～</span></p>
                        </div>
                      </li>
                      <li class="swiper-slide car_box">
                        <div class="car_box__item"><img src="/lib/images/inspectiondetail/section01/example_2.png" alt="トヨタ　ヤリス 車両重量：990kg"></div>
                        <div class="car_box__price">
                          <h3>トヨタ　ヤリス<br>車両重量：990kg</h3>
                          <p class="price">{{ inspectionExamplePrices.yaris }}<span class="tax">円（税込）～</span></p>
                        </div>
                      </li>
                      <li class="swiper-slide car_box">
                        <div class="car_box__item"><img src="/lib/images/inspectiondetail/section01/example_3.png" alt="ホンダ　ヴェゼル 車両重量：1,350㎏"></div>
                        <div class="car_box__price">
                          <h3>ホンダ　ヴェゼル<br>車両重量：1,350㎏</h3>
                          <p class="price">{{ inspectionExamplePrices.vezel }}<span class="tax">円（税込）～</span></p>
                        </div>
                      </li>
                      <li class="swiper-slide car_box">
                        <div class="car_box__item"><img src="/lib/images/inspectiondetail/section01/example_4.png" alt="トヨタ　ヴォクシー 車両重量：1,620kg"></div>
                        <div class="car_box__price">
                          <h3>トヨタ　ヴォクシー<br>車両重量：1,620kg</h3>
                          <p class="price">{{ inspectionExamplePrices.voxy }}<span class="tax">円（税込）～</span></p>
                        </div>
                      </li>
                    </ul>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                  </div>
                </div>

              </div>
            </section>
            </main>
          </template>
          <section v-if="paypayCampaignUrl !== ''" class="section white-panel mb1p pd4">
            <p class="mb8 mt8 text-center">
              <img src="/lib/images/paypay_campaign_202501.png" class="w80p" alt="コミっとPayPayキャンペーン">
            </p>
            <p>
              <button v-on:click='campaignOpenBrowser' class="button button-green w80p pd8 radius200 fs14 pb10 pt8">詳細はこちら</button>
            </p>
            <br>
          </section>
        </article>
      </div>
    </div>
    <div class="floating-button-wrapper" v-if="!inspectionFlag">
      <div class="floating-button">
        <a v-on:click='nextPage(ssInfo, profileInfo, nativeData, versionData)'>
          <img src="/lib/images/inspectiondetail/fv/fv_btn_sp.png" alt="オンラインで見積り" />
        </a>
      </div>
    </div>
    <component :is="'style'">
      .floating-button-wrapper {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 15px 0;
        z-index: 1000;
        text-align: center;
      }
      @supports (-webkit-touch-callout: none) {
        .floating-button-wrapper {
          bottom: 80px !important;
          position: fixed !important;
          z-index: 9999 !important;
        }
        .content-wrapper {
          padding-bottom: 200px !important;
        }
      }
      .floating-button {
        width: 90%;
        max-width: min(calc(656 / 750 * 100vw), 656px);
        margin: 0 auto;
      }
      .floating-button img {
        max-width: 100%;
        height: auto;
        display: block;
      }
      .content-wrapper {
        padding-bottom: 100px;
      }
    </component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import inspection from '@/store/Api/inspection'
import manufacturersApi from '@/store/Api/manufacturers'
import modal from '@/assets/v3/modal'
import Loading from '@/views/v3/Loading.vue'
import ssApi from '@/store/Api/Common/ss'
import profileApi from '@/store/Api/Common/profile'
import appVerApi from '@/store/Api/Common/appVer'
import { useSsInfoStore } from '@/store/ssInfo'
import { useProfileInfoStore } from '@/store/profileInfo'
import { useNativeDataStore } from '@/store/nativeData'
import { useVersionDataStore } from '@/store/versionData'

// 日本時間の2026年11月1日0時から、コミっと車検の料金例を改定する。
const REVISION_AT = Date.parse('2026-10-13T14:00:00+09:00')
const BEFORE_REVISION = { nbox: 74420, yaris: 86830, vezel: 94730, voxy: 106730 }
const AFTER_REVISION = { nbox: 75540, yaris: 87740, vezel: 95640, voxy: 107640 }

export default {
  data () {
    return {
      // 画面を開いた時点の現在日時で、料金例の新旧を判定する。
      inspectionExampleNow: Date.now(),
      loading: true,
      inspectionFlag: true,
      Manufacturer: {},
      profileInfo: [],
      ssInfo: [],
      pitlockshopDetails: {},
      mpDisabled: false,
      moveMpTopButtonDisabled: false,
      webviewMaintenance: [],
      gaId: process.env.VUE_APP_GA_ID,
      isViewGatag: JSON.parse(process.env.VUE_APP_IS_VIEW_GA_TAG || 'false'),
      observedNodes: [],
      paypayCampaignUrl: ''
    }
  },
  beforeRouteLeave () {
    this.removePageLayout()
  },
  beforeDestroy () {
    // beforeRouteLeaveが上手く発火しなかった時の保険
    this.removePageLayout()
  },
  destroyed () {
    // beforeRouteLeaveが上手く発火しなかった時の保険
    this.removePageLayout()
  },
  methods: {
    ...mapActions('INSPECTION', [
      'setInspection',
      'setDetail'
    ]),
    openErrorModal (message) {
      modal.alert(message)
    },
    eventTrackMoveInspection () {
      this.nativeEVENTSet('ShakenButton', 'MOVED_SYAKEN_TOP', 'TAP')
    },
    eventTrackStartInspectionFromCarcareTop () {
      this.nativeEVENTSet('ShakenButton', 'MOVED_SHAKEN_MITSUMORI_FROM_CARCARE_TOP', 'TAP')
    },
    eventTrackMoveLease () {
      this.nativeEVENTSet('LeaseButton', 'MOVED_LEASE_TOP', 'TAP')
    },
    setProfileInfo (profileInfo) {
      this.profileInfo = profileInfo
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    setWebviewMaintenance (webviewMaintenance) {
      this.webviewMaintenance = webviewMaintenance
    },
    inspectionTopPage (nativeData, versionData) {
      this.eventTrackMoveInspection()
      this.$router.push({
        name: 'InspectionTopV3',
        query: {
          tsid: nativeData.tsid,
          popinfoid: nativeData.popinfoid,
          otoken: nativeData.otoken,
          x_cls_app_version: versionData.appVersion,
          x_cls_os: versionData.platform,
          x_cls_os_version: versionData.osVersion
        }
      })
    },
    leaseTopPage (nativeData, versionData) {
      this.eventTrackMoveLease()
      this.$router.push({
        name: 'LeaseTopV3',
        query: {
          tsid: nativeData.tsid,
          popinfo_id: nativeData.popinfoid,
          otoken: nativeData.otoken,
          x_cls_app_version: versionData.appVersion,
          x_cls_os: versionData.platform,
          x_cls_os_version: versionData.osVersion
        }
      })
    },
    nextPage (ssInfo, profileInfo, nativeData, versionData) {
      // メンテナンス時はメンテ画面に遷移
      if (this.webviewMaintenance.inspection) {
        this.inspectionTopPage(nativeData, versionData)
        return
      }
      // 条件入力に遷移
      this.eventTrackStartInspectionFromCarcareTop()
      const ssInfoStore = useSsInfoStore()
      ssInfoStore.ssInfo = ssInfo
      const profileInfoStore = useProfileInfoStore()
      profileInfoStore.profileInfo = profileInfo
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = nativeData
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = versionData

      this.$router.push({ name: 'CarV3' })
    },
    campaignOpenBrowser () {
      const url = this.paypayCampaignUrl + this.nativeData.popinfoid
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.openBrowser(url)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.openBrowser.postMessage(url)
      }
    },
    // 動的に増えた要素監視を開始するメソッド
    observeDynamicTags () {
      // MutationObserver インスタンスを作成
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (
                node.nodeType === Node.ELEMENT_NODE &&
                ['LINK', 'SCRIPT', 'STYLE', 'IFRAME', 'DIV', 'NOSCRIPT', 'SPAN'].includes(node.tagName)
              ) {
                console.log('add_tag', node)
                this.observedNodes.push(node)
              }
            })
          }
        })
      })

      // headとbodyを監視
      this.observer.observe(document.body, { childList: true, subtree: true })
      this.observer.observe(document.head, { childList: true, subtree: true })
    },
    removeAllObservedTags () {
      this.observedNodes.forEach((node) => {
        if (node.parentNode) {
          node.remove()
        }
      })

      // 削除後、リストをクリア
      this.observedNodes = []
    },
    removePageLayout () {
      // このページ専用のcssの削除
      this.removeExternalCSS('https://use.typekit.net/jhq7wgy.css')
      this.removeExternalCSS('https://cdn.jsdelivr.net/npm/yakuhanjp@3.2.0/dist/css/yakuhanjp.min.css')
      this.removeExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.4.5/css/swiper.min.css')
      this.removeExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/froala-editor/3.2.7/css/froala_style.min.css')
      this.removeExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/magnific-popup.min.css')
      this.removeExternalCSS('https://unpkg.com/scroll-hint@latest/css/scroll-hint.css')
      this.removeExternalCSS('/lib/css/inspectiondetail.css')
      this.removeExternalCSS('https://sdk.gig.goleadgrid.com/section-assets/template_sections.css?1a29b19769e9cd62e1e9a47547857205eab76cdd')
      this.removeExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/highlight.js/10.7.1/styles/vs2015.min.css')
      this.removeExternalCSS('https://cdn.jsdelivr.net/npm/@splidejs/splide@latest/dist/css/splide.min.css')
      // GTMスクリプトを削除
      const gtmScript = document.getElementById('gtm-script')
      if (gtmScript) gtmScript.remove()

      // Google Site Verificationのmetaタグを削除
      const metaTag = document.getElementById('google-verification')
      if (metaTag) metaTag.remove()

      // このページ専用のjsの削除
      // mathjaxは状態のリセットもしないといけない
      this.removeMathJaxScript('https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js')
      this.removeExternalJS('https://code.jquery.com/jquery-3.4.1.min.js')
      this.removeExternalJS('https://unpkg.com/scroll-hint@latest/js/scroll-hint.min.js')
      this.removeExternalJS('https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.4.5/js/swiper.min.js')
      this.removeExternalJS('/lib/js/inspectionedetail.js')
      this.removeExternalJS('/lib/js/webfontconfig.js')
      this.removeExternalJS('https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js')
      this.removeExternalJS('https://cdn.embedly.com/widgets/platform.js')
      this.removeExternalJS('https://cdnjs.cloudflare.com/ajax/libs/highlight.js/10.7.1/highlight.min.js')
      this.removeExternalJS('https://cdnjs.cloudflare.com/ajax/libs/highlightjs-line-numbers.js/2.8.0/highlightjs-line-numbers.min.js')
      this.removeExternalJS('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js')
      this.removeExternalJS('https://cdn.jsdelivr.net/npm/@splidejs/splide-extension-auto-scroll@0.5.3/dist/js/splide-extension-auto-scroll.min.js')

      // webfontconfig付与されるクラスを削除
      document.documentElement.classList.remove(
        'wf-notosansjp-n4-active',
        'wf-notosansjp-n5-active',
        'wf-notosansjp-n7-active',
        'wf-active'
      )
      // クラスリストが空であれば classの記述を削除(残っていても動作に支障はでないが削除する)
      if (!document.documentElement.classList.length) {
        document.documentElement.removeAttribute('class')
      }

      // 監視中に増えた要素の削除(主に依存関係で自動挿入されてしまう物を削除)
      this.removeAllObservedTags()
      // MutationObserver を停止
      if (this.observer) {
        this.observer.disconnect()
      }
    },
    // cssを動的に読み込む
    loadExternalCSS (href) {
      return new Promise((resolve) => {
        // すでに読み込まれているか確認
        const existingLink = Array.from(document.querySelectorAll('link')).find(link =>
          link.href.includes(href)
        )
        if (existingLink) {
          resolve() // すでに存在する場合はスキップ
          return
        }

        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = href
        document.head.appendChild(link)

        link.onload = () => {
          console.log(`loaded CSS: ${href}`)
          resolve()
        }
        link.onerror = () => {
          console.warn(`Failed to load CSS: ${href}`)
          resolve()
        }
      })
    },
    removeExternalCSS (src) {
      return new Promise((resolve) => {
        const links = document.querySelectorAll('link')

        links.forEach((link) => {
          if (link.href.includes(src)) {
            link.parentNode.removeChild(link)
            console.log(`CSS Removed: ${src}`)
          }
        })
        resolve()
      })
    },
    // jsを動的に読み込む
    loadExternalJS (url, id) {
      return new Promise((resolve, reject) => {
        // 既に同じURLのスクリプトが読み込まれている場合はスキップ
        const existingScript = Array.from(document.getElementsByTagName('script')).find(
          script => script.src.includes(url)
        )

        if (existingScript) {
          console.log(`JS already loaded: ${url}`)
          resolve()
          return
        }

        const script = document.createElement('script')
        script.src = url
        script.async = true
        if (id) {
          script.id = id
        }

        script.onload = () => {
          console.log(`JS Loaded: ${url}`)
          resolve()
        }

        script.onerror = () => {
          console.warn(`Failed to load JS: ${url}`)
          resolve()
        }

        document.body.appendChild(script)
      })
    },

    removeExternalJS (url) {
      return new Promise((resolve) => {
        // 指定されたURLのスクリプトを検索
        const script = Array.from(document.getElementsByTagName('script')).find(
          script => script.src.includes(url)
        )

        if (script) {
          script.parentNode.removeChild(script)
          console.log(`JS Removed: ${url}`)
          resolve()
        } else {
          resolve()
        }
      })
    },
    removeMathJaxScript (url) {
      return new Promise((resolve) => {
        // MathJaxの状態をリセット
        if (window.MathJax) {
          window.MathJax.typesetClear() // 数式のキャッシュをクリア
          delete window.MathJax // グローバルオブジェクトを削除
        }

        // スクリプトタグを削除
        const script = Array.from(document.getElementsByTagName('script')).find(
          (s) => s.src.includes(url)
        )

        if (script) {
          script.parentNode.removeChild(script)
          console.log(`MathJax script removed: ${url}`)
        }

        resolve()
      })
    }
  },
  computed: {
    inspectionExamplePrices () {
      const prices = this.inspectionExampleNow >= REVISION_AT ? AFTER_REVISION : BEFORE_REVISION
      return Object.fromEntries(Object.entries(prices).map(([car, price]) => [car, price.toLocaleString('ja-JP')]))
    },
    ...mapGetters('INSPECTION', [
      'inspection',
      'detail'
    ]),
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      return getData
    },
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.$route.query.x_cls_app_version
      getData.platform = this.$route.query.x_cls_os
      getData.osVersion = this.$route.query.x_cls_os_version
      return getData
    },
    firstRegistrationOnWareki: function () {
      return this.toWareki(this.detail[0].inspection_estimate.first_registration_on)
    },
    noscriptContent () {
      return `
          <iframe src="https://www.googletagmanager.com/ns.html?id=${this.gaId}" 
                  height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `
    }
  },
  watch: {
    loading (newVal) {
      // ローディングが終わってDOM要素が表示されたタイミング以降にjsをよみこまなければいけない
      if (!newVal) {
        setTimeout(() => {
          // 動的に増えたタグの監視を開始
          this.observeDynamicTags()
          this.loadExternalJS('https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js', 'loadExternalJS')
          this.loadExternalJS('https://unpkg.com/scroll-hint@latest/js/scroll-hint.min.js')
          this.loadExternalJS('https://code.jquery.com/jquery-3.4.1.min.js').then(() => this.loadExternalJS('https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.4.5/js/swiper.min.js').then(() => this.loadExternalJS('/lib/js/inspectionedetail.js')))
          this.loadExternalJS('/lib/js/webfontconfig.js')
          this.loadExternalJS('https://cdn.embedly.com/widgets/platform.js')
          this.loadExternalJS('https://cdnjs.cloudflare.com/ajax/libs/highlight.js/10.7.1/highlight.min.js').then(() => this.loadExternalJS('https://cdnjs.cloudflare.com/ajax/libs/highlightjs-line-numbers.js/2.8.0/highlightjs-line-numbers.min.js'))
          this.loadExternalJS('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js')
          this.loadExternalJS('https://cdn.jsdelivr.net/npm/@splidejs/splide-extension-auto-scroll@0.5.3/dist/js/splide-extension-auto-scroll.min.js')

          if (this.isViewGatag === true) {
            // dataLayerの初期化
            const newEvent = {
              'gtm.start': new Date().getTime(),
              event: 'gtm.js',
              consent: 'default'
            }

            // dataLayer内に同じeventがない場合のみ追加
            if (Array.isArray(window.dataLayer)) {
              if (!window.dataLayer.some(item => item.event === newEvent.event)) {
                window.dataLayer.push(newEvent)
              }
            }

            // GTMタグを追加
            if (!document.getElementById('gtm-script')) {
              const gtmScript = document.createElement('script')
              gtmScript.async = true
              gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + this.gaId
              gtmScript.id = 'gtm-script'
              document.head.appendChild(gtmScript)
            }

            // Google Site Verificationのmetaタグ
            if (!document.getElementById('google-verification')) {
              const metaTag = document.createElement('meta')
              metaTag.name = 'google-site-verification'
              metaTag.content = process.env.VUE_APP_GA_CONTENT
              metaTag.id = 'google-verification'
              document.head.appendChild(metaTag)
            }
          }
        }, 100)
      }
    }
  },
  async mounted () {
    console.log(location.href)
    this.nativeEVENTSet('ShakenButton', 'MOVED_INSPECTION_DETAIL', 'TAP')
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    // 現行アプリで本画面を開いた場合、setTitleがネイティブに存在しないためエラーを無視する
    // ref: https://gitlab.ssl.iridge.jp/cosmo-oil/web-front/-/issues/192
    try {
      // タイトル
      this.appDisplayTitle('コミっと車検')
    } catch (e) {
      console.log('error: appDisplayTitle')
      console.log(e.message)
    }

    let isApiError = false

    this.paypayCampaignUrl = process.env.VUE_APP_PAYPAY_CAMPAIGN_URL ?? ''

    // webviewメンテナンス情報を取得
    await appVerApi.get().then(res => {
      this.setWebviewMaintenance(res.data.webviewMaintenance)
    }).catch(e => {
      console.log('appVerApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.$route.query.x_cls_app_version, this.$route.query.x_cls_os, this.$route.query.x_cls_os_version)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.versionData.appVersion = this.versionData.appVersion ? this.versionData.appVersion : '0.0.0'
      this.versionData.platform = this.versionData.platform ? this.versionData.platform : 'iRidge'
      this.versionData.osVersion = this.versionData.osVersion ? this.versionData.osVersion : '0.0'
    }

    // profile情報マスタ取得。
    await profileApi.get(this.nativeData.tsid, this.nativeData.otoken, this.appVersionMakeRequestHeder(this.versionData)).then(res => {
      this.setProfileInfo(res.data.body)
    }).catch(e => {
      console.log('profile-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // ベストMYSSが存在している場合
    if (this.profileInfo.best_myss.length !== 0) {
      await ssApi.get(this.profileInfo.best_myss.code).then(res => {
        this.setSsInfo(res.data.body.ss_info)
      }).catch(e => {
        console.log('ss-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })
    }

    // inspection(予約)データ取得
    await inspection.get(this.$route.query.tsid).then(res => {
      this.setInspection(res.data)
    }).catch(e => {
      console.log('inspection-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    if (this.inspection.inspections.length !== 0) this.setDetail((await inspection.getDetail(this.inspection.inspections[0].id)).data)
    if (this.detail[0].id !== '') {
      // 車名（メーカーを取得する）
      await manufacturersApi.getDetail(this.detail[0].inspection_estimate.manufacturer_id).then(res => {
        this.Manufacturer = res.data.manufacturer
      }).catch(e => {
        console.log('manufactuer-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })
    } else {
      this.inspectionFlag = false
    }
    // イベントトラッキング
    // 予約がある場合
    if (this.inspectionFlag) {
      if (this.detail[0].id !== '') {
        // 申し込み
        if (this.detail[0].status_code === 1) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Mosikomi' })
        }
        // 日程確定
        if (this.detail[0].status_code === 2) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Nitteikakutei' })
        }
        // お預かり
        if (this.detail[0].status_code === 3) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Azukarityu' })
        }
        // 車検完了
        if (this.detail[0].status_code === 4) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Kanryo' })
        }
        // 支払い完了（現金払い）
        if (this.detail[0].status_code === 5 && this.detail[0].payment_method_code === 2) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Cash' })
        }
        // 支払い完了（クレジット払い）
        if (this.detail[0].status_code === 5 && this.detail[0].payment_method_code === 1) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Credit' })
        }
      }
    }
    this.nativePVset('CAR_MENU')

    if (!this.inspectionFlag) {
      // 車検詳細用ページ用のcss
      this.loadExternalCSS('https://use.typekit.net/jhq7wgy.css')
      this.loadExternalCSS('https://cdn.jsdelivr.net/npm/yakuhanjp@3.2.0/dist/css/yakuhanjp.min.css')
      this.loadExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.4.5/css/swiper.min.css')
      this.loadExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/froala-editor/3.2.7/css/froala_style.min.css')
      this.loadExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/magnific-popup.min.css')
      this.loadExternalCSS('https://unpkg.com/scroll-hint@latest/css/scroll-hint.css')
      this.loadExternalCSS('/lib/css/inspectiondetail.css')
      this.loadExternalCSS('https://sdk.gig.goleadgrid.com/section-assets/template_sections.css?1a29b19769e9cd62e1e9a47547857205eab76cdd')
      this.loadExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/highlight.js/10.7.1/styles/vs2015.min.css')
      this.loadExternalCSS('https://cdn.jsdelivr.net/npm/@splidejs/splide@latest/dist/css/splide.min.css')

      // 動的にcss適用する際にちらつきが発生する場合があるため500ミリ秒遅くローディング中を解除する
      setTimeout(() => {
        this.loading = false
      }, 500)
    }

    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading
  }
}

</script>
